import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Switch,
  Tooltip,
} from '@material-ui/core';

import useStyles from './styles';
import IOSSwitch from 'components/DynamicForm/controls/SwitchControl/iosSwitch';
import { PlaylistAdd, Close } from '@material-ui/icons';

function PlusMinusButton(props) {
  const classes = useStyles();
  const {
    checked,
    onChange,
    name,
    size,
    color,
    tooltipStateOne,
    tooltipStateTwo,
    IconStateOne,
    IconStateTwo,
    ...rest
  } = props;

  const handleClick = () => {
    const target = {
      name,
      checked: !checked,
    };
    onChange({
      target,
    });
  };

  const Icon = checked ? IconStateTwo : IconStateOne;
  const tooltipMessage = checked ? tooltipStateTwo : tooltipStateOne;

  return (
    <div 
      className={classes.plusMinusContainer}
      onClick={handleClick}
    >
      <Tooltip title={tooltipMessage} arrow>
        <Icon
          name={name}
          color={color}
          style={{
            cursor: 'pointer',
          }}
          {...rest}
        />
      </Tooltip>
    </div>
  );
}

function SwitchControl(props) {
  const classes = useStyles();
  const {
    events = {},
    error,
    helperText,
    label,
    name,
    onChange,
    size,
    type,
    value,
    variant,
    ...rest
  } = props;

  const Control = type === 'checkbox'
    ? Checkbox
    : variant === 'ios'
      ? IOSSwitch
      : variant === 'button'
        ? PlusMinusButton
        : Switch;

  const handleChange = ({ target: { checked } }) => {
    const target = {
      name,
      value: checked,
    };
    onChange({
      target,
    });

    if (events.onChange) {
      events.onChange(target);
    }
  };

  if (variant === 'button') {

    return (
      //<FormControl error={error}>
      <Control
        checked={value}
        color="primary"
        name={name}
        size={size}
        onChange={handleChange}
        {...rest}
        
      />
    );
  }

  return (<FormControl error={error}>
    <FormGroup>
      <FormControlLabel
        className={error ? classes.error : undefined}
        control={<Control
          checked={value}
          color="primary"
          name={name}
          size={size}
          onChange={handleChange}
          {...rest}
        />}
        label={label}
      />
      <FormHelperText children={helperText} />
    </FormGroup>
  </FormControl>);
}


PlusMinusButton.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium']),
  color: PropTypes.string,
  tooltipStateOne: PropTypes.string,
  tooltipStateTwo: PropTypes.string,
  IconStateOne: PropTypes.elementType,
  IconStateTwo: PropTypes.elementType,
};

PlusMinusButton.defaultProps = {
  tooltipStateOne: 'Expandir',
  tooltipStateTwo: 'Colapsar',
  IconStateOne: PlaylistAdd,
  IconStateTwo: Close,
};

SwitchControl.defaultProps = {
  size: 'small',
  type: 'switch',
  value: false,
  onChange: () => { },
};

SwitchControl.propTypes = {
  events: PropTypes.object,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  type: PropTypes.oneOf(['checkbox', 'switch']),
  value: PropTypes.bool,
  onChange: PropTypes.func,
  variant: PropTypes.oneOf(['ios', 'button']),
};

export default SwitchControl;
